import { moduleProviderFactory } from "core/providers";
import { NikoPatientSalesOrder } from "application/niko-patient-sales-order/pages";

(function () {
    moduleProviderFactory.application.register({
        routes: [
            {
                name: "master.app.main.sales-order",
                pattern: "/patient-sales-orders",
                children: [
                    {
                        name: "master.app.main.sales-order.niko-sales-order",
                        pattern: "",
                        authorization: "administrationSection.read",
                        component: NikoPatientSalesOrder,
                        tabTitle: "Patient Sales Orders",
                        data: {
                            title: "MENU.SALES_ORDER"
                        }
                    },
                ]
            }
        ],
        menu: [
            {
                title: "MENU.NIKO",
                icon: "package",
                authorization: 'administrationSection.read',
                order: 6,
                subMenu: [
                    {
                        title: "MENU.SALES_ORDER",
                        breadcrumbTitle: "MENU.PATIENT_SALES_ORDER",
                        authorization: 'administrationSection.read',
                        route: "master.app.main.sales-order.niko-sales-order",
                        order: 2,
                    },
                ],
            },
        ]
    });
})();